'use client';

import React, { type FC } from 'react';

export const ThemeButton: FC = () => {
    const toggleTheme = (): void => {
        document.body.classList.add('change-theme');
        localStorage.setItem('theme', document.body.classList.toggle('dark') ? 'dark' : 'light');

        setTimeout(() => {
            document.body.classList.remove('change-theme');
        }, 0);
    };

    return (
        <button onClick={toggleTheme} id="theme-toggle" aria-label="Zmień motyw kolorystyczny strony">
            <span id="theme-toggle-circle" className="bg-white" />
        </button>
    );
};
